var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { useBaseTranslate, useIsI18nRouter } from '../../hooks';
import GridifyItem from './GridifyItem';
var Gridify = function (_a) {
    var data = _a.data, removeMargin = _a.removeMargin, children = _a.children, selectOptions = _a.selectOptions, download = _a.download;
    var classes = useStyles();
    var translate = useBaseTranslate();
    var isI18nRouter = useIsI18nRouter();
    var isMobile = useMediaQuery('(max-width: 800px)');
    var dataToMap = useMemo(function () { return Array.isArray(data) ? data : data.data; }, [data]);
    var title = useMemo(function () { return !isI18nRouter && data.title; }, [data, isI18nRouter]);
    return (_jsxs("div", __assign({ className: clsx(!removeMargin && 'grid-section', 'gridify') }, { children: [title && (_jsx("div", __assign({ className: 'grid-title' }, { children: typeof title === "string" ? title : translate(title) }), void 0)),
            _jsx(Grid, __assign({ item: true, container: true, direction: 'row', xs: 12, justify: "space-between" }, { children: dataToMap.map(function (item) { return (_jsx(Grid, __assign({ item: true, xs: isMobile ? 12 : 6, className: clsx(classes.gridItem, !isI18nRouter && classes.notRouterGridItem) }, { children: _jsx(GridifyItem, { item: item, download: download, selectOptions: selectOptions }, void 0) }), item.id)); }) }), void 0), children] }), void 0));
};
export default Gridify;
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        gridItem: (_a = {},
            _a[theme.breakpoints.down(800)] = {
                paddingBottom: 8
            },
            _a),
        notRouterGridItem: {
            width: '10vw'
        }
    });
});
//# sourceMappingURL=Gridify.js.map